import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { tokenName } from '@angular/compiler';
import { Injectable } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import * as deepEqual from 'deep-equal';
import { of, throwError } from 'rxjs';
import { catchError, finalize } from 'rxjs/operators';
import { environment } from '../../environments/environment';
import { ConsoleColors } from '../_enums/consoleColors.enum';
import { enum_ErrorMessages } from '../_enums/errorMessage.enum';
import { enum_GenericEvents, GenericEvent } from '../_enums/genericEvents.enum';
import '../_interfaces/string.interface';
import { GlobalService } from './global.service';
// import { WindowRef } from '../_helpers/window.ref';
// import { NavigationService } from './navigation.service';

@Injectable()
export class ApiService {

    private headers: HttpHeaders;
    public isCalculating: boolean = false;
    public currentDataObj: any = null;
    public isLoginValidationExpired: boolean = false;

    private _recalculateTimeout: any = null;

    // private navigationService: NavigationService,
    constructor(
        private httpClient: HttpClient,
        private globalService: GlobalService) {
        console.debug('ApiService().constructor()');
    }

    private setHeaders(method: string, url: string) {
        console.debug('ApiService().setHeaders()');

        if ((environment.calculator.apiKey == null || environment.calculator.apiKey === undefined) || (environment.calculator.clientId == null || environment.calculator.clientId === undefined)) {
            return;
        }

        let tMethod = method;
        let tDateStamp = new Date();
        let tClientApiKey = environment.calculator.apiKey;
        let tUrl = url;

        let tContentType = (tMethod === 'GET') ? '' : 'application/json;charset=UTF-8';
        let ct = tMethod + tUrl + tContentType + tDateStamp.toUTCString().replace('UTC', 'GMT');
        let ctSHA256 = CryptoJS.HmacSHA256(ct, tClientApiKey);
        let ctBase64 = CryptoJS.enc.Base64.stringify(ctSHA256);

        this.headers = new HttpHeaders({
            'X-TW-API-CLIENTID': environment.calculator.clientId,
            'X-TW-DATE': tDateStamp.toUTCString().replace('UTC', 'GMT'),
            'X-TW-SIGNATURE': ctBase64,
            'Content-Type': tContentType
        });

        if (window.location.href.indexOf('soa') != -1) {
            this.headers = this.headers.set('X-TW-PDFServerGen', '1');
        }
    }

    // calculator PASSED FROM THE RESOLVER
    init(calculator: any) {
        console.debug('ApiService().init()');

        const queryString = window.location.search;
        const urlParams = new URLSearchParams(queryString);
        const tkn = urlParams.get('tkn')

        let tUrl;
        if (environment.urls.init.indexOf('https://') !== -1 || environment.urls.init.indexOf('http://') !== -1) {
            tUrl = environment.urls.init;
        }
        else {
            if (this.globalService.calculator) {
                tUrl = (environment.urls.base + environment.urls.init).format(this.globalService.calculator.clientCode, this.globalService.calculator.clientCalculator);
            }
            else {
                tUrl = (environment.urls.base + environment.urls.init).format(environment.calculator.clientCode, environment.calculator.clientCalculator);
            }
        }

      let data = null;

      // used by the email auth after redirect
      // for instances when cookies are disabled
        if (tkn) {
            data = {
              "tkn": tkn
              };
        }

        // tUrl = "https://run.mocky.io/v3/02b60ffd-783c-41ca-a65b-3cb396dedf5e";

        if (!environment.switches.withCredentials) {
            data = {
              "empId": "00000000"
            };
        } else if (window.location.pathname.indexOf('soa') > -1) {
            data = {
                "empId": this.getParameterByName('empId')
            };
        }

        this.setHeaders('POST', tUrl);
        return this.httpClient
            .post(tUrl, ((data == null) ? null : data), {
                headers: this.headers,
                observe: 'response'
            })
            .pipe(catchError(this.handleError));
    }

    initWithEmpId(empId: string) {
        console.debug('ApiService().init()');


        let tUrl;
        if (environment.urls.initAfterLogin.indexOf('https://') !== -1 || environment.urls.init.indexOf('http://') !== -1) {
            tUrl = environment.urls.init;
        }
        else {
            if (this.globalService.calculator) {
                tUrl = (environment.urls.base + environment.urls.initAfterLogin).format(this.globalService.calculator.clientCode, this.globalService.calculator.clientCalculator);
            }
            else {
                tUrl = (environment.urls.base + environment.urls.initAfterLogin).format(environment.calculator.clientCode, environment.calculator.clientCalculator);
            }
        }

        let data = {
            "empId": empId
        };

        this.setHeaders('POST', tUrl);
        return this.httpClient
            .post(tUrl, ((data == null) ? null : data), {
                headers: this.headers,
                observe: 'response'
            })
            .pipe(catchError(this.handleError));
    }

    checkCalc(): boolean {
        //check if data model has changed against one in memory. This check is done to see if new calcuation call is required.
        console.debug('ApiService().checkCalc()');
        let areEqual = (deepEqual(this.currentDataObj, this.globalService.calculatorModel.members));
        this.currentDataObj = JSON.parse(JSON.stringify(this.globalService.calculatorModel.members));
        if (!areEqual) {
            this.isCalculating = true;
            console.debug('ApiService().checkCalc() --> data change found');
        }
        return areEqual;
    }

    // CREATED JUST IN CASE WE NEED THE MEMBER CHECK THAT WON'T TRIGGER THE ROUND SPINNED TO DISPLAY
    isCurrentMemberUnchanged(currentMember: any = null): any {
        //check if data model has changed against one in memory. This check is done to see if new calcuation call is required.
        console.debug('ApiService().isCurrentMemberUnchanged()');

        let areEqual;

        if (currentMember) {
            areEqual = (deepEqual(this.globalService.calculatorModel.memberInitial, currentMember));
        }
        else {
            areEqual = (deepEqual(this.globalService.calculatorModel.memberInitial, this.globalService.calculatorModel.members.current));
        }

        return areEqual;
    }

    calc(data: any) {
        console.debug('ApiService().calc()');

        //set current data object
        this.currentDataObj = data;

        //this.clientEnvironment = obj;
        let tUrl = (environment.urls.base + environment.urls.calc).format(environment.calculator.clientCode, environment.calculator.clientCalculator);
        // let tUrl = "https://run.mocky.io/v3/02b60ffd-783c-41ca-a65b-3cb396dedf5e";

        this.setHeaders('POST', tUrl);
        return this.httpClient.post(tUrl, { 'members': data }, { headers: this.headers, observe: 'response' })
            .pipe(catchError(this.handleError))
            .pipe(finalize(
                () => {
                    console.debug('ApiService().calc() --> finalize');
                    this.isCalculating = false;
                }
            ));
    }

    recalculate(timeout: number = 250) {
        if (this._recalculateTimeout) {
            clearTimeout(this._recalculateTimeout);
        }
        this._recalculateTimeout = setTimeout((() => {
            //DO SOMETHING BELOW
            // if isNavigationEnabled it's high likely that there is
            if (!this.globalService.calculatorModel.navigationModel.isNavigationEnabled) {
                console.debug('\n\n%c1. recalculate() not proceeding - navigationModel.isNavigationEnabled is disabled posssibly with invalid inputs.', ConsoleColors.DEFAULT);
                this._recalculateTimeout = null;
                return;
            }
            console.debug('\n\n%c1. recalculate()  ---------- api.service ----------', ConsoleColors.HEADING);
            if (!this.checkCalc()) {
                console.debug('2. recalculate() - !this.checkCalc()');
                this.isCalculating = true;
                this.calc(this.currentDataObj).subscribe(
                    (response: any) => {
                        if (response.body) {
                            console.debug('3 response: ', response);
                            let results = response.body;

                            for (const scenarioKey in results) {
                                if (Object.prototype.hasOwnProperty.call(results, scenarioKey)) {
                                    const result = results[scenarioKey];
                                    this.globalService.calculatorModel.results[scenarioKey] = result;
                                }
                            }

                            // this.globalService.calculatorModel.results = results;
                            console.debug('4. updated this.globalService.calculatorModel.results: ', this.globalService.calculatorModel.results);
                        }
                    },
                    (error: any) => {
                        console.debug('\n\n%c CALCULATE ERROR response ', ConsoleColors.WARNING, error);
                        switch (error) {
                            case enum_ErrorMessages.ERRORMESSAGE_403:

                                this.globalService.triggerGenericEvent(new GenericEvent(enum_GenericEvents.OPEN_MODAL_CONFIRM_TIMEDOUT));
                                // this.windowRef.nativeWindow.location.reload();

                                // this.windowRef.nativeWindow.open('', '_parent');
                                // this.navigationService.goRoute('/' + this.globalService.calculator.clientCalculator + '/login');
                                break;
                            default:
                                break;
                        }
                    }
                );
            }
            this._recalculateTimeout = null;
        }).bind(this), timeout);
    }

    getParameterByName(name) {
        name = name.replace(/[\[]/, "\\\[").replace(/[\]]/, "\\\]");
        let regexS = "[\\?&]" + name + "=([^&#]*)";
        let regex = new RegExp(regexS);
        let results = regex.exec(window.location.href);

        //console.log('2020-02-03_18:55:07 >>>>> ----- >>>>>');
        //console.log('1. ===== window.location.href: ', window.location.href);
        //console.log('2020-02-03_18:55:07 <<<<< ----- <<<<<');

        return results === null ? null : decodeURIComponent(results[1].replace(/\+/g, " "));
    }

    private handleError(error: HttpErrorResponse) {
        console.debug('ApiService().handleError()');
        if (error.error instanceof ErrorEvent) {
            // A client-side or network error occurred. Handle it accordingly.
            console.error('An error occurred:', error.error.message);
        } else {
            // The backend returned an unsuccessful response code.
            // The response body may contain clues as to what went wrong,
            console.error(
                `Backend returned code ${error.status}, ` +
                `body was: ${error.error}`);
        }

        switch (error.status) {
            case 403:
                return throwError(enum_ErrorMessages.ERRORMESSAGE_403);
            case 404:
                return throwError(enum_ErrorMessages.ERRORMESSAGE_404);
            case 500:
                return throwError(enum_ErrorMessages.ERRORMESSAGE_500);
            default:
                return throwError(`${error.status} - ${error.error}`);
        }
    }
}
